// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"74dffdc4","667":"894dd0bd","977":"8b23f0b7"}[chunkId] + ".chunk.js";
};